import { render, staticRenderFns } from "./BtnPermissionItem.vue?vue&type=template&id=01c6fc54&scoped=true"
import script from "./BtnPermissionItem.vue?vue&type=script&lang=js"
export * from "./BtnPermissionItem.vue?vue&type=script&lang=js"
import style0 from "./BtnPermissionItem.vue?vue&type=style&index=0&id=01c6fc54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c6fc54",
  null
  
)

export default component.exports